// actions.ts (в каталоге page)
import { GET_PAGE_NAME, PageAction, SET_PAGE_NAME } from './types'

export const getPageName = (name: string): PageAction => ({
  type: GET_PAGE_NAME,
  payload: name,
})

export const setPageName = (name: string): PageAction => ({
  type: SET_PAGE_NAME,
  payload: name,
})
